module.exports = require("@gauzy/plugin-registry");